<script lang="ts" setup>
import { RuleForm } from "../types/plusTypes";
import { formatNumber } from "~/utils/miscUtils";

// --- Types ---
// -------------

// ---- Props & Emits ----
defineProps<{
  ruleForm: RuleForm;
  surveyCompleted: boolean;
  isReadOnly?: boolean;
  selectedSectorLabels?: string[];
}>();

const emit = defineEmits<{
  (e: "update:surveyCompleted", value: boolean): void;
}>();
// -----------------------

// ---- Data & Computed ----
// -------------------------

// --- Utility Functions ---
// -------------------------

// ---- Event Handlers -----
// -------------------------
</script>
<template>
  <div class="current-inputs">
    <span class="current-inputs-heading">
      <h4 class="">Current Inputs</h4>
      <el-button
        v-if="!isReadOnly"
        size="small"
        @click="() => emit('update:surveyCompleted', false)"
      >
        Edit
      </el-button>
    </span>

    <div v-if="ruleForm.couple" class="inputInfo">
      <span class="a1"> Age: {{ ruleForm.age }} </span>
      <span class="a2"> Age: {{ ruleForm.otherAge }} </span>
      <span class="i1"> Income: ${{ formatNumber(ruleForm.income, 0) }} </span>
      <span class="i2">
        Income: ${{ formatNumber(ruleForm.otherIncome, 0) }}
      </span>
    </div>
    <div v-else class="inputInfo">
      <span class="a1"> Age: {{ ruleForm.age }} </span>
      <span class="i1"> Income: ${{ formatNumber(ruleForm.income, 0) }} </span>
    </div>
    <div
      v-if="selectedSectorLabels && selectedSectorLabels.length > 0"
      class="sectorInfo"
    >
      <span class="sectorLabel">Sectors:</span>
      <div class="sectorSelected">
        <span
          v-for="label in selectedSectorLabels"
          :key="label"
          class="sectorTag"
        >
          {{ label }}
        </span>
      </div>
    </div>
  </div>
</template>
<style lang="less">
.current-inputs {
  font-weight: 450;

  .current-inputs-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
